import React, { useMemo } from "react";
import type { AgendaConsultant, AgendaGridSlot } from "../agendaTypes";
import { buildVisitWeatherHint } from "../agendaWeatherHint";
import { useAgendaWeatherContext } from "../context/AgendaWeatherContext";
import ScheduleDetailPanel, {
  ScheduleDetailPanelParam,
} from "./ScheduleDetailPanel";

type ScheduleDetailPanelWithWeatherProps = {
  open: boolean;
  param: ScheduleDetailPanelParam | null;
  schedules: AgendaGridSlot[];
  consultants: AgendaConsultant[];
  onClose: () => void;
  onDemarcate: (scheduleId: number, scheduleDate: string) => void;
  onUpdate: (
    scheduleId: number,
    scheduleParam: string,
    videoCall: boolean
  ) => void;
  onVisitOutcomeUpdated?: () => void;
  onScheduleAnother?: (scheduleParam: string, propertyId: number | null) => void;
};

const ScheduleDetailPanelWithWeather: React.FC<
  ScheduleDetailPanelWithWeatherProps
> = ({
  open,
  param,
  schedules,
  consultants,
  onClose,
  onDemarcate,
  onUpdate,
  onVisitOutcomeUpdated,
  onScheduleAnother,
}) => {
  const { hourRainByCity, cityByName, location } = useAgendaWeatherContext();

  const weatherHint = useMemo(() => {
    if (!open || !param) {
      return null;
    }

    return buildVisitWeatherHint({
      scheduleParam: param.scheduleParam,
      targetScheduleId: param.targetScheduleId,
      schedules,
      consultants,
      hourRainByCity,
      weatherByCity: cityByName,
      weatherCityName: location?.city,
    });
  }, [open, param, schedules, consultants, hourRainByCity, cityByName, location?.city]);

  return (
    <ScheduleDetailPanel
      open={open}
      param={param}
      onClose={onClose}
      onDemarcate={onDemarcate}
      onUpdate={onUpdate}
      onVisitOutcomeUpdated={onVisitOutcomeUpdated}
      onScheduleAnother={onScheduleAnother}
      weatherHint={weatherHint}
    />
  );
};

export default ScheduleDetailPanelWithWeather;
